import React from 'react';

import cs from 'classnames';

import type {ReactNode} from 'react';
type Props = {
  icon?: string;
  onSidebar?: boolean;
  onPopover?: boolean;
  head: ReactNode | string;
  children?: ReactNode | string;
  className?: string;
  classNameOverwrite?: string;
};

const NoResultsMessage = ({
  icon,
  head,
  onSidebar = false,
  onPopover,
  children,
  className,
  classNameOverwrite,
}: Props) => {
  const IconTag = onPopover ? 'h3' : 'h2';
  const HeadTag = onPopover ? 'h5' : onSidebar ? 'h4' : 'h3';
  const childreClass = onSidebar ? 'font-weight-light px-3' : 'lead';
  return (
    <div
      className={cs(
        classNameOverwrite != null
          ? classNameOverwrite
          : cs('my-5 text-center', className)
      )}
    >
      <IconTag className="text-muted">
        {icon != null ? <i className={`far fa-fw ${icon}`} /> : null}
      </IconTag>
      <HeadTag className={onSidebar ? 'px-3' : ''}>{head}</HeadTag>
      {children != null ? (
        <div className={`${childreClass} py-4 text-muted`}>{children}</div>
      ) : null}
    </div>
  );
};

export default NoResultsMessage;
